import { Component, NgZone, OnDestroy } from '@angular/core';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { LoggingService } from './services/logging.service';
import { Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import { ConnectHelper } from './Utility/ConnectHelper';
import { Menu } from './model/header/menu';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  title = 'XB Control';
  public subscription!: Subscription;
  currenturl: any;
  isProd: boolean = false;
  public flags!: string;
  public menus: Menu[] = [];

  constructor(private loggingService: LoggingService, private authService: AuthService, private zone: NgZone, private router: Router,
    private activatedRoute: ActivatedRoute, private connectHelper: ConnectHelper, private cookieService: CookieService) {

    loggingService.logEvent('App Component Loaded');
    this.subscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.currenturl = event.url;
        
        if (!environment.production) {
          let xbcSessionInput = document.getElementById('xbcSession') as HTMLInputElement;
          xbcSessionInput.value = this.cookieService.get(AuthService.userSessionKey)!;
        }
      }
    });
  }

  ngOnInit() {
    this.initDXPWebRouting();

    let xbcSession = this.cookieService.get(AuthService.userSessionKey);
    this.flags = ConnectHelper.flags;
    this.connectHelper.initialize();
    if (xbcSession) {
      this.authService.login(xbcSession).subscribe(data => {
        if (data && data.isAuthorized) {
          this.menus = data.menus;
          this.connectHelper.activateSession();
          this.onLoginSuccess();
          let url = new URL(window.location.href);
          this.zone.run(() => {
            this.router.navigate([url.pathname]);
          });
        }
        else {
          this.zone.run(() => {
            this.router.navigate([this.authService.getLoginUrl()]);
          });
        }
      });
    }
    else {
      this.zone.run(() => {
        this.router.navigate([this.authService.getLoginUrl()]);
      });
    }
  }

  initDXPWebRouting(): void {
    Object.assign(window, {
      navigateByRouting: (href: string) => {
        if (href) {
          const routeSegments = href.replace(/^#/, '').split('?');
          const path = routeSegments[0];
          const queryString = routeSegments[1] ? routeSegments[1].trim() : null;
          const queryParams = {};
          if (queryString) {
            const searchParams = new URLSearchParams(queryString); searchParams.forEach((value, key) => {
              Object.assign(queryParams, { [key]: value });
            });
          }
          this.zone.run(() => {
            this.router.navigate([path], { queryParams });
          });
        }
      }
    });
  }

  private signoutEvent: any = (event: any) => {
    this.connectHelper.executeSignout(event);
    window.removeEventListener(ConnectHelper.signout, this.signoutEvent);
  }

  private onLoginSuccess(): void {
    window.addEventListener(ConnectHelper.signout, this.signoutEvent)
    AuthService.keepAliveTimer = setInterval(() => {
      this.authService.keepAlive().subscribe(
        data => {
          if (!data) {
            this.connectHelper.signout();
          }
        }
      )
    }, 1000 * 60 * 2)
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
